import React, { ComponentProps, useMemo } from 'react';

import { StepWrapper } from '../Forms/components/FormLayout';
import { PeriodSelector } from '../Forms/components/PeriodSelector';
import { ProductValues } from '../States';
import { PeriodOptions } from '~/types/IPurchase';

type Props = {
  values: ProductValues;
  periodOptions?: PeriodOptions;
};

type Options = ComponentProps<typeof PeriodSelector>['options'];

export function Period({ values, periodOptions }: Props) {
  const options = useMemo<Options>(
    () => {
      const allOptions: Options = [
        {
          label: 'En gång',
          value: 'Once'
        },
        {
          label: 'Var tredje månad',
          value: 'EveryThirdMonth'
        },
        {
          label: 'Varannan månad',
          value: 'EveryOtherMonth'
        },
        {
          label: 'Varje månad',
          value: 'Month'
        }
      ];

      if (periodOptions) {
        const availableOptions = allOptions
          .filter((option) => periodOptions[option.value]?.enabled)
          .sort((optionA, optionB) =>
            (periodOptions[optionA.value]?.order || 0) - (periodOptions[optionB.value]?.order || 0)
          );

        if (availableOptions.length > 0) {
          return availableOptions;
        }
      }

      return allOptions;
    },
    [periodOptions]
  );

  return (
    <StepWrapper>
      <StepWrapper marginTop="tiny">
        <PeriodSelector
          options={options}
          onChange={values.handlers.setProductPeriod}
          value={values.productOptions.product.period}
          tinyLayout="50"
          smallLayout="50"
          largeLayout="50"
        />
      </StepWrapper>
    </StepWrapper>
  );
}
